export function findAction(card, searchTerm): any {
    return card.actions?.find((action) => {
        return action.name.indexOf(searchTerm) >= 0;
    });
}